import React, { useContext, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { ToastContext } from 'app/context/ToastContext';
import { getConfigs, saveConfigs, sendTestEmail } from 'app/api/configurationApi';
import { Divider } from 'primereact/divider';
import { Checkbox } from 'primereact/checkbox';

const validationSchema = Yup.object({
  sprievodka_podpis: Yup.string().max(255, 'Max 255 znakov'),
});

const ConfigurationWidget = () => {
  const [loading, setLoading] = useState(true);
  const [configuration, setConfiguration] = useState(null);

  const { showSuccess, showError } = useContext(ToastContext);

  useEffect(() => {
    getConfigs()
      .then(response => {
        // setPersons([{ label: buildLabel(response.data), value: response.data.id }]);
        setConfiguration(response.data);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleSave = (values: any) => {
    setLoading(true);

    saveConfigs(values)
      .then(response => {
        showSuccess('Úspech', 'Konfiguracie úspešne uložene.');
        setConfiguration(response.data);
      })
      .catch(error => {
        console.error('Error creating configs:', error);
        showError('Chyba', error.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  const onSendTestEmail = () => {
    setLoading(true);

    sendTestEmail()
      .then(response => {
        showSuccess('Úspech', 'Testovací email bol poslaný.');
        setConfiguration(response.data);
      })
      .catch(error => {
        console.error(error);
        showError('Chyba', error.response?.data?.detail);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="card">
      <>
        {loading && (
          <div className="flex justify-content-center">
            <ProgressSpinner />
          </div>
        )}

        {!loading && (
          <Formik
            initialValues={
              configuration
                ? configuration
                : {
                    sprievodka_podpis: '',
                    sprievodka_podpis3: '',
                    posielat_notifikacie_o_nezaplateni: '',
                  }
            }
            validationSchema={validationSchema}
            onSubmit={values => {
              handleSave(values);
            }}
          >
            {({ isSubmitting, setFieldValue, values, errors }) => {
              return (
                <Form onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }} className="p-fluid">
                  <div className="grid">
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="sprievodka_podpis">Meno na sprievodke za NFA</label>
                        <Field name="sprievodka_podpis" as={InputText} />
                        <ErrorMessage name="sprievodka_podpis" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="zmluva_prilohy_cesta">Cesta kde sa ukladajú prílohy ku zmluvám</label>
                        <Field name="zmluva_prilohy_cesta" as={InputText} />
                        <ErrorMessage name="zmluva_prilohy_cesta" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="email_prilohy_cesta">Cesta kde sa ukladajú e-mailové prílohy</label>
                        <Field name="email_prilohy_cesta" as={InputText} />
                        <ErrorMessage name="email_prilohy_cesta" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="na_stiahnutie_cesta">Cesta kde sa ukladajú dokumenty na stiahnutie</label>
                        <Field name="na_stiahnutie_cesta" as={InputText} />
                        <ErrorMessage name="na_stiahnutie_cesta" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="email_notifikovanie_provizie">Email na ktorý sa budú posielať notifikácie</label>
                        <Field name="email_notifikovanie_provizie" as={InputText} />
                        <ErrorMessage name="email_notifikovanie_provizie" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="ostatne_cesta">Cesta ku ostatným dokumentom</label>
                        <Field name="ostatne_cesta" as={InputText} />
                        <ErrorMessage name="ostatne_cesta" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="posielat_notifikacie_o_nezaplateni">Posielať notifikácie o nezaplatení</label>
                        <Checkbox
                          onChange={e => void setFieldValue('posielat_notifikacie_o_nezaplateni', e.checked)}
                          checked={values.posielat_notifikacie_o_nezaplateni === 'true' || values.posielat_notifikacie_o_nezaplateni}
                        ></Checkbox>
                        <ErrorMessage name="posielat_notifikacie_o_nezaplateni" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="generovat_provizie_z_vlastnych">Generovať provízie z vlastných platieb</label>
                        <Checkbox
                          onChange={e => void setFieldValue('generovat_provizie_z_vlastnych', e.checked)}
                          checked={values.generovat_provizie_z_vlastnych === 'true' || values.generovat_provizie_z_vlastnych}
                        ></Checkbox>
                        <ErrorMessage name="generovat_provizie_z_vlastnych" component="div" className="p-error" />
                      </div>
                    </div>

                    <Divider align="left">
                      <div className="inline-flex align-items-center">
                        <b>Interný email</b>
                      </div>
                    </Divider>
                    <div className="col-12 md:col-4">
                      <div className="p-field">
                        <label htmlFor="smtp_server">SMTP Server</label>
                        <Field name="smtp_server" as={InputText} />
                        <ErrorMessage name="smtp_server" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-2">
                      <div className="p-field">
                        <label htmlFor="smtp_server_port">SMTP Server Port</label>
                        <Field name="smtp_server_port" as={InputText} />
                        <ErrorMessage name="smtp_server_port" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="email_username">E-mail meno</label>
                        <Field name="email_username" as={InputText} />
                        <ErrorMessage name="email_username" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <label htmlFor="email_password">E-mail heslo</label>
                        <Field type="password" name="email_password" as={InputText} />
                        <ErrorMessage name="email_password" component="div" className="p-error" />
                      </div>
                    </div>
                    <div className="col-12 md:col-6">
                      <div className="p-field">
                        <Button style={{ backgroundColor: '#e31818' }} type="button" onClick={onSendTestEmail}>
                          Poslať testovací email
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className="p-d-flex p-jc-between">
                    <Button style={{ backgroundColor: '#e31818' }} type="submit" label="Uložiť" icon="pi pi-check" disabled={loading} />
                  </div>
                </Form>
              );
            }}
          </Formik>
        )}
      </>
    </div>
  );
};

export default ConfigurationWidget;
